module.exports = __webpack_public_path__ + "img/DiscrepancyDonutSupplier.7604b9d1.png";